<template>
  <div class="change">
    <v-base-card>
      <template v-slot:heading>
        <div class="change-heading">
          <p class="change-heading__text mr-4">テスト作成</p>
          <p class="change-heading__text">問題差し替え</p>
        </div>
      </template>

      <template v-slot:content>
        <v-section-panel useBreak>
          <template v-slot:content>
            <v-container class="py-0" fluid>
              <v-row>
                <v-col :cols="stepCols" class="py-0" v-resize="setStepCols">
                  <v-stepp :stepps="stepps" disabled/>
                </v-col>
              </v-row>
            </v-container>
            <v-container fluid>
              <v-row>
                <v-col cols=6>
                  <v-result-table/>
                </v-col>
                <v-col cols=6 class="pa-0">
                  <v-bar-charts/>
                </v-col>
              </v-row>
            </v-container>
        <p v-if="isPresetMode" class="mb-0 setting-alert">※最初から解答重複の注意が出ることがありますが，意図の違う出題であり，弊社基準では許容としております。</p>
        <p v-if="isPresetMode" class="ml-4 setting-alert">お心懸かりございましたらご確認ください。</p>
        <p class="setting-alert">※問題を差し替える場合は、内容のバランスや解答重複にご注意ください。</p>
        <p class="mb-0 setting-alert">※この画面を開かれたまま１時間以上操作されないと、データが保存されません。</p>
        <p class="ml-4 setting-alert">離席される場合や、作業を一時中断する場合は、「途中保存」または「次へ」のボタンを押してください。</p>
          </template>
        </v-section-panel>
        <v-section-panel useBreak>
          <template v-slot:content>
            <v-container fluid>
              <v-row>
                <v-col cols=6 class="pa-0 pr-2">
                  <v-base-card mt="mt-6">
                    <template v-slot:heading>
                      出題する問題
                    </template>
                    <template v-slot:content>
                      <draggable v-model="usedItems" group="items">
                        <v-part-area
                          v-for="(item, index) in usedItems"
                          :class="{'mt-10': index !== 0}"
                          :contentCode="item.contentCode"
                          :partNo="index+1"
                          :key="`used-${index}`"
                          :chapterName="item.chapterName"
                          :pageRange="item.pageRange"
                          :shinkenkyuNumber="item.shinkenkyuNumber"
                          :material="item.material"
                          :athleticEvent="item.athleticEvent"
                          :questionType="item.questionType"
                          :questionCnt="item.questionCnt"
                          :difficulty="item.difficulty"
                          :viewPoint="item.viewPoint"
                          :usedTime="item.usedTime"
                          :usedCntByFiscalYear="item.usedCntByFiscalYear"
                          :active="targetPartNo==index"
                          :alert="duplicatedIds.includes(item.id)"
                          :questionImage="item.questionImage[0]"
                          :showDeleteBtn="usedItems.length != 1"
                          :listeningTime="item.listeningTime"
                          :favoriteContentId="item.favoriteContentId"
                          :isFavorite="item.isFavorite"
                          @on-click-preview="showDialog(item)"
                          @on-click-remove="removePart"
                          @on-click-favorite="onClickFavorite"
                        >
                        <template v-slot:options>
                          <div class="part-area__fotter">
                            <v-btn class="switch-btn" color="secondary" small @click.stop="changeTarget(index)">選択</v-btn>
                            <v-btn class="search-btn" color="secondary" small @click.stop="showSearchDialog(index)">検索</v-btn>
                          </div>
                        </template>
                      </v-part-area>
                      </draggable>
                    </template>
                  </v-base-card>
                </v-col>
                <v-col cols=6 class="pa-0 pl-2">
                  <v-base-card mt="mt-6">
                    <template v-slot:heading>
                      差し替え候補問題
                    </template>
                    <template v-slot:content>
                      <v-part-area
                        v-for="(item, index) in displayEnableItems"
                        :class="{'mt-10': index !== 0}"
                        :key="`enable-${index}`"
                        :contentCode="item.contentCode"
                        :chapterName="item.chapterName"
                        :questionCnt="item.questionCnt"
                        :pageRange="item.pageRange"
                        :shinkenkyuNumber="item.shinkenkyuNumber"
                        :material="item.material"
                        :athleticEvent="item.athleticEvent"
                        :questionType="item.questionType"
                        :difficulty="item.difficulty"
                        :viewPoint="item.viewPoint"
                        :usedTime="item.usedTime"
                        :usedCntByFiscalYear="item.usedCntByFiscalYear"
                        :questionImage="item.questionImage[0]"
                        :listeningTime="item.listeningTime"
                        :favoriteContentId="item.favoriteContentId"
                        :isFavorite="item.isFavorite"
                        @on-click-preview="showDialog(item)"
                        @on-click-favorite="onClickFavorite"
                      >
                        <template v-slot:options>
                          <div class="part-area__fotter">
                            <!-- 前へ追加 -->
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <div class="upper-btn" v-on="on">
                                  <v-btn color="secondary" small @click.stop="replaceContents(item,'addPrev',index), isAddPrev = true" v-bind="attrs" :disabled="targetPartNo==null">
                                    <v-icon color="white" dark small>
                                      mdi-arrow-up-bold
                                    </v-icon>
                                  </v-btn>
                                </div>
                              </template>
                              <span>{{tooltipMassage(targetPartNo, 'addPrev')}}</span>
                            </v-tooltip>
                            <!-- 差し替え -->
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <div class="change-btn" v-on="on">
                                  <v-btn color="secondary" small @click.stop="replaceContents(item,'change',index), isChange = true" v-bind="attrs" :disabled="targetPartNo==null">
                                    <v-icon color="white" dark small>
                                      mdi-arrow-left-right-bold
                                    </v-icon>
                                  </v-btn>
                                </div>
                              </template>
                              <span>{{tooltipMassage(targetPartNo, 'change')}}</span>
                            </v-tooltip>
                            <!-- 後ろへ追加 -->
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <div class="down-btn" v-on="on">
                                  <v-btn color="secondary" small @click.stop="replaceContents(item,'addNext',index), isAddNext = true" v-bind="attrs" :disabled="targetPartNo==null">
                                    <v-icon color="white" dark small>
                                      mdi-arrow-down-bold
                                    </v-icon>
                                  </v-btn>
                                </div>
                              </template>
                              <span>{{tooltipMassage(targetPartNo, 'addNext')}}</span>
                            </v-tooltip>
                          </div>
                        </template>
                      </v-part-area>

                      <!-- ページング処理 -->
                      <v-pagination
                        v-if="enableItems.length>pagination.itemsPerPage"
                        v-model="pagination.page"
                        :length="pages"
                        color="secondary"
                      />

                      <!-- 確定ボタン -->
                      <!-- <v-btn class="mt-4" color="secondary" @click.stop="searchDialog = true">再検索</v-btn> -->
                    </template>
                  </v-base-card>
                </v-col>
              </v-row>
            </v-container>
            <div class="mt-5 buttons">
              <p class="mb-2 ml-5" style="color:red;font-size: 13px;" v-if="!isValid">問題が一つも選択されていません</p>
              <!-- preview -->
              <v-preview-buttons
                :disabled="!isValid"
                :previewImages="previewImages"
                @open="pdfDownloadAndShow"
              />
            </div>
          </template>
        </v-section-panel>
        <!-- 確定ボタン -->
        <v-btn color="gray" @click="toBack()">{{screenName}}へ戻る</v-btn>
        <!-- 途中保存 -->
        <v-save-button
          :save-fnc="save"
          :disabled="!isValid"
        />
        <!-- プレビュー更新ボタン -->
        <v-btn
          class="ml-3"
          color="#4989d1"
          style="color: white;"
          @click="previewAllUpdate()"
        >
          プレビュー更新
        </v-btn>
        <v-btn color="secondary" class="ml-3" @click="toResult()" :disabled="!isValid">次へ</v-btn>
      </template>
    </v-base-card>

    <v-dialog
      v-model="dialog"
      :width="dialogImageWidth"
      :height="dialogImageHeight + 100"
    >
      <v-card ref="dialog" class="pa-2">

        <v-row v-if="scriptImage.length>0 && dialogImage==='question'">
          <v-col :cols="selectedSubjectIsKokugo ? 3 : 6" class="py-0">
            <v-img
              ref="dialog-image"
              :height="dialogImageHeight"
              contain
              :src="image"
              v-for="(image, i) in showedImage"
              :key="`dialog_image_${i}`"
              class="mb-2"
            />
          </v-col>
          <v-col :cols="selectedSubjectIsKokugo ? 9 : 6" class="py-0">
            <v-img
              ref="dialog-image"
              :height="dialogImageHeight"
              contain
              :src="image"
              v-for="(image, i) in scriptImage"
              :key="`dialog_script_image_${i}`"
              class="mb-2"
            />
          </v-col>
        </v-row>

        <v-img v-else
          ref="dialog-image"
          :height="dialogImageHeight"
          contain
          :src="image"
          v-for="(image, i) in showedImage"
          :key="`dialog_image_${i}`"
          class="mb-2 py-0"
        />
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            dark
            @click.stop="changeDialogImage"
          >
            {{dialogImage === 'question' ? '解答' : '問題'}}
          </v-btn>

          <v-btn
            color="green darken-1"
            dark
            @click="dialog = false"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <transition name="slide-right">
      <v-attention-area type="alert" float class="alert" v-if="duplicatedIds.length !== 0">
        <template slot="content">
          <!-- duplicatedIds -->
          <p class="mb-0" style="font-weight:bold" v-html="alertMessage"></p>
        </template>
      </v-attention-area>
    </transition>
    <transition name="slide-right">
      <v-attention-area type="warning" float class="warning" v-if="warningMessage">
        <template slot="content">
          <p class="mb-0" style="font-weight:bold" v-html="warningMessage"></p>
        </template>
      </v-attention-area>
    </transition>

    <v-dialog v-model="searchDialog" persistent max-width="620px">
      <v-loading ref="searchLoading"/>
      <v-card>
        <v-card-title>
          <span class="headline">差し替え候補問題 検索</span>
        </v-card-title>
        <v-card-text>
          <v-choice-grades
            v-if="!selectedSubjectHasChild"
            class="my-6"
            :selected="$store.getters['user/isShingaku'] ? 10 : $store.state.top.selectedGrade.id"
            @onChange="changeGrade"
            :disabled="false"
            hide-details
            :modeShingaku="$store.getters['user/isShingaku']"
          />
          <v-radio-group
            v-model="selectedShakaiOptionId"
            hide-details
            row
            v-if="selectedSubjectHasChild"
            @change="searchShakaiOptionChanged"
          >
            <v-radio
              v-for="(option, index) in selectedSubjectOptions"
              :key="index"
              :label="option.name"
              :value="option.id"
              color="secondary"
            ></v-radio>
          </v-radio-group>
          <template v-if="searchOnlyShingaku && searchGradeId === 10">
            <p>進学教材を選んだ場合は、単元番号を入力してください</p>
            <v-shingaku-unit-range-group
              class="mt-7"
              v-if="searchOnlyShingaku"
              :textFieldCols='{ lg: 5, md: 5, sm: 5 }'
            />
          </template>
          <template v-else>
            <v-choice-publishers
              class="my-6"
              v-if="!selectedSubjectOptionIsPublisherNone"
              :disabled="!isPublishersSelectable"
            ></v-choice-publishers>
            <p>小学校内容の問題を選択したい場合は、教材ページを「0-0」と入力してください</p>
            <v-publisher-pages-group
              class="mt-7"
              v-if="!selectedSubjectOptionIsPublisherNone"
              :textFieldCols='{ lg: 5, md: 5, sm: 5 }'
            />
          </template>
          <v-choice-athletic-events
            v-if="selectedSubjectOptionIsTaiiku"
          />
          <v-choice-materials />
          <v-select
            v-if="showQuestionType"
            class="select-field"
            v-model="selectedQuestionTypeId"
            :items="questionTypes"
            item-text="name"
            item-value="id"
            label="問題内容"
          />
          <v-select
            class="select-field"
            v-model="selectedPointId"
            :items="points"
            item-text="name"
            item-value="id"
            label="観点"
          />
          <!-- お気に入りのみか -->
          <v-checkbox
            key="favorite_key"
            v-model="selectedOnlyFavorite"
            label="お気に入りのみ"
            color="secondary"
            hide-details
          />
          <v-text-field
            v-if="isDevMode"
            class="select-field"
            v-model="questionCode"
            label="問題コード"
          />

          </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="searchDialog = false">閉じる</v-btn>
          <v-btn color="blue darken-1" text @click="searchQuestions">検索</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
import draggable from 'vuedraggable'

import VPartArea from '@/components/molecules/PartArea'
import VBaseCard from '@/components/molecules/BaseCard'
import VSectionPanel from '@/components/molecules/SectionPanel'
import VResultTable from '@/components/molecules/ResultTable'
import VChoiceGrades from '@/components/molecules/ChoiceGrades'
import VChoicePublishers from '@/components/molecules/ChoicePublishers'
import VPublisherPagesGroup from '@/components/molecules/PublisherPagesGroup'
import VShingakuUnitRangeGroup from '@/components/molecules/ShingakuUnitRangeGroup'
import VChoiceMaterials from '@/components/molecules/ChoiceMaterials'
import VChoiceAthleticEvents from '@/components/molecules/ChoiceAthleticEvents'
import VChoiceSearchOption from '@/components/molecules/ChoiceSearchOption'
import VStepp from '@/components/molecules/Stepp'
import VBarCharts from '@/components/organizms/BarCharts'
import VAttentionArea from '@/components/molecules/AttentionArea'
import VPreviewButtons from '@/components/molecules/PreviewButtons'
import VSaveButton from '@/components/molecules/SaveButton'
import VLoading from '@/components/organizms/Loading'
import config from "../../config"
import { getStepCols } from '../../plugins/responsive'

import { mapGetters } from 'vuex'

export default {
  components: {
    VPartArea,
    VBaseCard,
    VSectionPanel,
    VResultTable,
    draggable,
    VChoiceGrades,
    VChoicePublishers,
    VPublisherPagesGroup,
    VShingakuUnitRangeGroup,
    VChoiceMaterials,
    VChoiceAthleticEvents,
    VChoiceSearchOption,
    VStepp,
    VBarCharts,
    VAttentionArea,
    VPreviewButtons,
    VSaveButton,
    VLoading
  },

  data: () => ({
    new_image: [],
    dialog: false,
    dialogImage: null,
    dialogImageHeight: '',
    dialogImageWidth: '',
    dialogItem: null,
    showedImage: null,
    scriptImage: [],
    searchDialog: false,
    enableItems:[],
    dialogQuestionImage: null,
    dialogAnswerImage: null,
    targetPartNo: null,
    stepps: [
      {no: 1, text: '問題差し替え', to: '/teacher/change', complete: false, editable: false},
      {no: 2, text: 'プレビュー', to: '/teacher/result', complete: false, editable: false},
      {no: 3, text: '配点設定', to: '/teacher/score_setting', complete: false, editable: false},
      {no: 4, text: 'テスト登録', to: '/teacher/regist_exam', complete: false, editable: false},
    ],
    changeFormItems: {},
    selectedShakaiOptionId: null,
    selectedQuestionTypeId: null,
    selectedAnswerTypeId: null,
    selectedPointId: null,
    selectedOnlyFavorite: false,
    duplicatedIds: [],
    alertMessage: '',
    // preview pdf
    previewImages: null,
    beforeGradeOptions: [
      { text: '現学年問題', value: false },
      { text: '前学年問題', value: true },
    ],
    beforeGradeFlag: false,
    searchGradeId: null,
    stepCols: getStepCols(),
    pagination: {
      page: 1,
      itemsPerPage: 10
    },
    questionCode: null,
    // 問題入替操作を行ったどうかを判断するフラグ
    isAddPrev: false,
    isChange: false,
    isAddNext: false,
    isDeleted: false,
    searchOnlyShingaku: false,
    selectedSearchOptionId: 1,
  }),

  async mounted() {
    // 進学教材用アカウント設定
    if (this.$store.getters['user/isShingaku']) {
      this.searchOnlyShingaku = true
      this.searchGradeId = 10
    }
    const targetSheetId = this.$store.state.sheet.sheetContentPages.id
    const params = {
      sheet: {
        step: config.step.REPLACE_CONTENT,
      }
    }

    await this.$axios.put('/api/v1/teacher/sheets/' + targetSheetId, params)
    await this.$store.dispatch('sheet/checkAnswerDuplicate')
    this.$store.commit('sheet/setAlertMessage')
    this.setDuplicateIds()
    // 検索対象学年の初期設定
    if (!this.searchOnlyShingaku) {
      this.searchGradeId = this.$store.state.top.selectedGrade?.id
    }

  },

  watch: {
    // 表示中の差し替え候補問題が無くなったらページング移動
    displayEnableItems() {
      if (this.displayEnableItems.length || this.pagination.page === 1) return
      this.pagination.page -= 1
    },
    searchGradeId(newVal) {
      this.searchOnlyShingaku = newVal === 10
    }
  },

  computed: {
    ...mapGetters([
      'selectedSubjectHasChild',
      'selectedSubjectIsKokugo',
      'selectedSubjectIsSugaku',
      'selectedSubjectOptionIsTaiiku',
      'selectedSubjectOptions',
      'selectedSubjectOptionIsPublisherNone',
    ]),
    ...mapGetters('sheet',[
      'isPresetMode',
    ]),
    isDevMode() {
      return process.env.NODE_ENV === 'development'
    },
    pages() {
      return Math.ceil(this.enableItems.length / this.pagination.itemsPerPage)
    },
    displayEnableItems() {
      return this.enableItems.slice(this.pagination.itemsPerPage*(this.pagination.page - 1), this.pagination.itemsPerPage*(this.pagination.page));
    },
    showQuestionType() {
      const nonShowSubjectCodes = Object.entries(config.subjects)
        .filter(subject => ['RIKA', 'CHIRI', 'REKISHI', 'KOUMIN'].includes(subject[0]))
        .map(subject => subject[1])
      return !nonShowSubjectCodes.includes(this.$store.state.top.currentSubjectCondition.code)
    },
    selectedSubject() {
      return this.$store.state.top.selectedSubject
    },
    questionTypes(){
      const subjectQuestionTypes = this.selectedSubject
        ? this.$store.state.master.allQuestionTypes
            .filter(questionType => { return questionType.subject_id === this.selectedSubject.id })
        : []

      return [{id: null, name: '指定なし', subject_id: null}].concat(subjectQuestionTypes)
    },
    answerTypes() {
      return this.$store.state.master.allAnswerFormats
    },
    points() {
      return [{id: null, name: '指定なし', code: 'none'}].concat(this.$store.state.master.allPoints)
    },
    usedItems: {
      get() {
        return this.$store.state.sheet.usedItems
      },
      set(value) {
        this.$store.commit('sheet/setIsUpdate', {type: 'all', isUpdate: true})
        this.$store.commit('sheet/setUsedItems', {
          usedItems: value
        })
      }
    },
    isValid(){
      return this.usedItems.length !== 0
    },
    screenName() {
      return this.isPresetMode ? 'プリセット選択画面' : '条件設定画面'
    },
    isPublishersSelectable() {
      if (this.$store.getters['user/isShingaku']) {
        return true
      }
      if (!this.selectedSubjectHasChild) {
        return false
      }
      const isSelectedShakaiOption = this.$store.state.top.selectedShakaiOptions
        .some(x => x.code === this.$store.state.top.currentSubjectCondition.code)
      if (isSelectedShakaiOption) {
        // すでに検索条件で指定された分野は教科書固定
        return false
      }
      return true
    },
    warningMessage() {
      return this.$store.state.sheet.warningMessage
    },
  },

  methods: {
    changeGrade(event) {
      this.searchGradeId = event
    },
    changeSearchOption(event) {
      this.selectedSearchOptionId = event
    },
    async previewAllUpdate() {
      // 強制的に更新するためにisUpdateをtrueにする
      this.$store.commit('sheet/setIsUpdate', {type: 'all', isUpdate: true})
      const answerReductionType = this.selectedSubjectIsSugaku && this.usedItems.length > 10 ? '2' : null
      this.$store.commit('sheet/setAnswerReductionType', { answerReductionType: answerReductionType })
      this.$app.$refs.loading.open({type: 'print', message: 'プレビュー更新中'})
      this.previewImages = null
      await this.save()
      await this.$store.dispatch('sheet/getSheetImages', {params:{type: 'all'}})
      this.$app.$refs.loading.close({})
    },
    async pdfDownloadAndShow(mode) {
      const isUpdate = this.$store.getters['sheet/getIsUpdate'][mode]
      if (isUpdate){
        const answerReductionType = this.selectedSubjectIsSugaku && this.usedItems.length > 10 ? '2' : null
        this.$store.commit('sheet/setAnswerReductionType', { answerReductionType: answerReductionType })
        this.$app.$refs.loading.open({type: 'print', message: 'プレビュー作成中'})
        this.previewImages = null
        await this.save()
        await this.$store.dispatch('sheet/getSheetImages', {params:{type:mode}})
        this.$app.$refs.loading.close({})
      }
      const questionFilePaths = this.$store.state.sheet.questionImages
      const answerFilePaths = this.$store.state.sheet.answerImages
      this.previewImages = this.makePreviewImages({ questionFilePaths, answerFilePaths })
    },
    makePreviewImages(imagePaths){
      var { questionFilePaths, answerFilePaths } = imagePaths
      questionFilePaths = questionFilePaths ?? []
      answerFilePaths = answerFilePaths ?? []
      const baseURL = this.$axios.defaults.baseURL
      return {
        question: {
          name: '問題',
          data: questionFilePaths.map(path => { return { src: baseURL + path, w: 1800, h: 1200 } })
        },
        answer: {
          name: '解答',
          data: answerFilePaths.map(path => { return { src: baseURL + path, w: 1800, h: 1200 } })
        },
      }
    },
    showDialog(item) {
      this.dialogItem = item
      this.dialog = !this.dialog;
      this.dialogImage = 'question';

      // 「出題する問題」の問題画像表示用
      this.showedImage = item.questionImage;
      // スクリプト画像の表示用
      this.scriptImage = item.scriptImage[0] ? item.scriptImage : []
      // 「問題」「解答」の切り替え表示用
      this.dialogQuestionImage = item.questionImage;
      this.dialogAnswerImage   = item.answerImage;
      this.setDiaologSize()
    },
    changeDialogImage() {
      this.dialogImage = this.dialogImage === 'question' ? 'answer' : 'question';
      this.showedImage = this.dialogImage === 'question' ? this.dialogQuestionImage : this.dialogAnswerImage;

      this.setDiaologSize()
    },
    setDiaologSize(){
      // 値の初期化
      this.dialogImageHeight = 0
      this.dialogImageWidth = 0

      let targetImages = [this.showedImage[0]]
      if (this.scriptImage[0] && this.dialogImage === 'question') targetImages.push(this.scriptImage[0])

      const imageSizes = []
      // スクリプト画像があれば100% なければ80%
      const widthRate = targetImages.length > 1
        ? 1 : this.$app.$el.clientWidth <= 1024
        ? 1 : 0.8
      //ダイアログの横幅最大値 = 画面横幅 - 左右のpadding 24 * 2
      const maxDialogWidth = this.$app.$el.clientWidth * widthRate - 48
      //ダイアログの縦幅最大値 = 画面vh * 90% - ボタンエリアの高さ 85
      const maxDialogHeight = window.innerHeight * 0.9 - 85
      //ダイアログの横幅最小値 = 下のボタンがキレない横幅
      const minDialogWidth = 250
      //ダイアログの横幅最小値 = 下のボタンがキレない高さ
      const minDialogHeight = 100
      // 表示する問題が国語の聞き取り問題か
      const isJaListeningQuestion = this.dialogItem.material === '聞き取り問題'

      targetImages.forEach(image => {
        var img = new Image();

        img.onload = () => {
          imageSizes.push({ width: img.width, height: img.height })

          // 画像を横並びにした時、横長か縦長かで分岐
          const width = imageSizes.map(image => image.width).reduce((value, sum) => { return sum + value })
          const height = Math.max(...imageSizes.map(image => image.height))

          if (height > width) {
            this.dialogImageHeight = maxDialogHeight
            this.dialogImageWidth = Math.max(width * (this.dialogImageHeight/height), minDialogWidth)
            if (this.dialogImageWidth > maxDialogWidth) {
              this.dialogImageWidth = maxDialogWidth
              this.dialogImageHeight = height * (maxDialogWidth/width)
            }
          } else {
            this.dialogImageWidth = maxDialogWidth
            this.dialogImageHeight = Math.max(height * (this.dialogImageWidth/width), minDialogHeight)
            if (this.dialogImageHeight > maxDialogHeight) {
              this.dialogImageHeight = maxDialogHeight
              this.dialogImageWidth = width * (maxDialogHeight/height)
            }
          }

          // 国語の聞き取り問題の場合は画面横幅いっぱいに広げる
          if (isJaListeningQuestion) this.dialogImageWidth = maxDialogWidth
          this.dialogImageWidth += 30
        }

        img.src = image;
      })

    },
    async removePart(targetIndex) {
      this.isDeleted = true
      this.$store.commit('sheet/setSplicedUsedItems', {
        targetIndex: targetIndex
      })
      await this.$store.dispatch('sheet/checkAnswerDuplicate')
      this.$store.commit('sheet/setAlertMessage')
      // 重複チェック(重複していても次へ進める)
      this.setDuplicateIds()
      this.$store.commit('sheet/setIsUpdate', {type: 'all', isUpdate: true})
    },
    showSearchDialog(partNo) {
      this.searchDialog = true;
      this.targetPartNo = partNo
      this.$store.commit('sheet/setTargetContent', {
        targetContent: this.usedItems[partNo]
      })

      // 選択した大問の検索条件を設定
      this.$store.commit(
        'setCurrentSubjectCondition',
        {
          currentSubjectCondition: this.$store.state.top.allConditions
            .find(x => x.code === this.usedItems[partNo].subjectCode)
        }
      )

      // 初期選択の教材設定
      this.$store.commit('changeCurrentSubjectCondition', {
        selectedMaterials: this.$store.state.master.allMaterials
        .filter(material => material.subject_id === this.selectedSubject.id)
      })

      if (this.selectedSubjectHasChild) {
        this.selectedShakaiOptionId = this.$store.state.master.allSubjects.find(subject => subject.code === this.$store.state.sheet.targetContent.subjectCode)?.id
      }

      this.selectedAnswerTypeId   = this.$store.state.sheet.targetContent.answerTypeIds[0]
    },
    changeTarget(index) {
      this.targetPartNo = this.targetPartNo === index ? null : index;
    },
    async searchQuestions() {
      this.$refs.searchLoading.open({type: 'normal', message: '検索中です'})
      const currentCondition = this.$store.state.top.currentSubjectCondition
      const gradeId = this.searchGradeId
      const subjectId = this.$store.state.master.allSubjects.find(subject => subject.code === currentCondition.code).id
      const condition = {
        grade_id: this.selectedSubjectHasChild || this.searchOnlyShingaku ? null : Number(gradeId),
        subject_id: this.selectedSubjectHasChild ? this.selectedShakaiOptionId : Number(subjectId),
        publisher_id: this.searchOnlyShingaku ? null : Number(currentCondition.selectedPublisher?.id),
        page_ranges: this.searchOnlyShingaku && this.selectedSearchOptionId === 1 ? [] : config.publisherNoneSubjecs.includes(currentCondition.code) ? [] : currentCondition.publisherPages.map(page => { return { start: Number(page.start), end: Number(page.end) } }),
        shinkenkyu_unit_ranges: this.searchOnlyShingaku && this.selectedSearchOptionId === 1 ? currentCondition.shinkenkyuUnitRanges.map(range => { return { start: Number(range.start), end: Number(range.end) } }) : [],
        material_ids: currentCondition.selectedMaterials.map(material => Number(material.id)),
        question_type_id: this.selectedQuestionTypeId,
        // answer_format_id: Number(this.selectedAnswerTypeId),
        point_id: this.selectedPointId,
        // 前学年フラグは全てfalseで検索
        before_grade_flag: this.beforeGradeFlag,
        is_change_question_flag: true,
        question_code: this.questionCode,
        athletic_event_ids: currentCondition.selectedAthleticEvents.map(athletic => Number(athletic.id)),
        only_favorite: this.selectedOnlyFavorite,
      }
      // 検索実行
      const res = await this.$axios.post('/api/v1/teacher/content_pages/search', { condition: condition })
      this.enableItems = res.data.map(contentPage => {
        // 既に出題する問題に表示されている問題は、条件に該当していても候補に表示しない
        const booleanArray = this.$store.state.sheet.usedItems.map(usedItem => {
          return usedItem.contentCode === contentPage.content.code
        })

        // 最後のfilter(v => v)でnullのものは取り除かれる
        if(booleanArray.includes(true)) return null
        return {
          // コンテンツ単位の表示用
          // sheetContentPageId: item[1].id, 候補問題はsheetContentPageに紐づいていない
          id:              contentPage.content.id,
          gradeId:         Number(contentPage.content.grade_id),
          contentCode:     contentPage.content.code,
          pageRange:       this.$store.getters['sheet/pageRangeText'](contentPage),
          questionCnt:     contentPage.content.question_cnt,
          usedTime:        contentPage.content.used_cnt,
          usedCntByFiscalYear: contentPage.content.used_cnt_by_fiscal_year,
          material:        contentPage.content.materials.map(material => material.name).join(', '),
          subject:         contentPage.content.subject,
          subjectCode:     contentPage.content.subject_code,
          athleticEvent:   contentPage.content.athletic_events.map(athletic => athletic.name).join(', '),
          // 大問プレビュー用
          questionImage:   contentPage.content.question_image_urls,
          answerImage:     contentPage.content.answer_image_urls,
          scriptImage:     contentPage.content.script_image_urls ? contentPage.content.script_image_urls : [null],
          // グラフ整形用
          chapterName:     contentPage.content.chapter_name,
          questionTypeIds: contentPage.content.questions.map(question => question.question_type_id),
          answerTypeIds:   contentPage.content.questions.map(question => question.answer_format_id),
          pointIds:        contentPage.content.questions.map(question => question.point_id),// pointIdsだけはsheet_questionsの値を参照する（観点変更後、再開することもあるから）
          viewPoint:       this.$store.state.master.allPoints.find((p) => p.id === contentPage.content.questions[0].point_id).name,
          materialKinds:   contentPage.content.materials.map(material => material.kind),
          materialIds:     contentPage.content.materials.map(material => material.id),
          // 解答重複チェック用
          answers:         contentPage.content.questions.map(question => question.answer),
          // 更新用
          // number:          item[1].number, 出題する順番の番号のため候補問題は使わない
          contentPageId:   contentPage.id,
          qeustions:       contentPage.content.questions,
          // リスニング再生時間
          listeningTime:   contentPage.content.listening_time,
          favoriteContentId: contentPage.content.favorite_content_id,
          isFavorite:      !!contentPage.content.favorite_content_id,
          shinkenkyuNumber: contentPage.content.shinkenkyu_number
            ? "単元" + String(contentPage.content.shinkenkyu_number).padStart(2, '0')
            : null,
          sheetQuestions:  contentPage.content.questions.map(question => {
            return {
              id: 'c'+String(question.id),
              questionId: question.id,
              number:     question.number,
              allot:      question.allot,
              pointId:    question.point_id,
              question:   question,
            }
          }),
        }
      }).filter(v => v) // 削除対象の問題はオブジェクトがnullになっているのでここで削除する

      // 検索結果が無かったらその旨表示
      if (!this.enableItems.length) {
        this.$toasted.global.error({ message: '問題がありません' })
        this.$refs.searchLoading.close()
        return false
      }

      if (this.selectedSubjectHasChild) {
        // 元々選択していなかった社会の分野が検索された場合、対象の分野として追加する
        const isAlreadySelectedShakaiOption =
          this.$store.state.top.selectedShakaiOptions.some(opt => opt.id === this.selectedShakaiOptionId)
        if (!isAlreadySelectedShakaiOption) {
          const option = this.$store.getters.selectedSubjectOptions.find(x => x.id === this.selectedShakaiOptionId)
          this.$store.commit('addSelectedShakaiOptions', { option: option })
        }
      }

      this.$store.commit('sheet/setEnableItems', {
        enableItems: this.enableItems
      })
      this.$refs.searchLoading.close()
      // モーダルを閉じる
      this.searchDialog = false;
    },
    async replaceContents(replaceContent, mode, index) {
      // 出題する問題未選択の場合
      if(!this.targetPartNo && typeof(this.targetPartNo) !== 'number') {
        this.$toasted.global.error({ message: '対象の問題を選択してください。' })
        return
      }
      // ページング対応（表示用候補問題の2ページ目以降でも差し替え反映されるように）
      const targetIndex = index + this.pagination.itemsPerPage*(this.pagination.page -1)

      // 問題差し替え・追加処理
      const params = {
        limitItemCount: this.$store.state.top.selectedSubject.code === config.subjects.SUGAKU ? 20 : 10,
        replaceContent: replaceContent,  // 追加、または差し替える問題
        targetPartNo: this.targetPartNo, // 選択中問題のindex
        mode: mode,                      // 処理モード（addPrev：１つ前に追加、addNext：１つ下に追加、change：差し替える）
        targetIndex: targetIndex,        // 差し替え・追加する候補問題のindex
      }

      this.$store.commit('sheet/setReplacedUsedItems', params)
      await this.$store.dispatch('sheet/checkAnswerDuplicate')
      this.$store.commit('sheet/setAlertMessage')
      this.setDuplicateIds()
      // 問題の選択状態を解除
      this.targetPartNo  = null
      // 候補問題の状態を更新
      this.enableItems   = this.$store.state.sheet.enableItems
      this.$store.commit('sheet/setIsUpdate', {type: 'all', isUpdate: true})
    },
    async setDuplicateIds() {
      // 重複チェック(重複していても次へ進める)
      this.duplicatedIds = this.$store.state.sheet.duplicatedAnswers.map(x => [x.contentId, x.replaceContentId]).flat().filter((x,i,self) => self.indexOf(x) === i)
      this.duplicatedIds = this.duplicatedIds.length>1 ? this.duplicatedIds : []
      this.alertMessage  = this.$store.state.sheet.alertMessage
    },
    async save() {
      // オリジナル作成の場合は差し替え問題検索条件を再開時用の検索条件にも反映しておく
      // かんたん作成の場合はデータ構造が違い検索条件を保存できないので何もしない
      if (!this.$store.getters['sheet/isPresetMode']) {
        const gradeId = this.$store.state.top.selectedGrade?.id
        const conditions = this.$store.getters.sendApiParams.reduce((accumulator, condition) => {
          const selectedSubject = this.$store.state.master.allSubjects.find(x => x.code == condition.code)
          accumulator.push({
            grade_id: this.$store.getters.selectedSubjectHasChild ? null : Number(gradeId),
            subject_id: Number(selectedSubject?.id),
            publisher_id: Number(condition.selectedPublisher?.id),
            page_ranges: condition.publisherPages.map(page => { return { start: Number(page.start), end: Number(page.end) } }),
            question_num: Number(condition.questionNum),
            difficulty_id: Number(condition.selectedDifficulty?.id),
            writing_question_flag: condition.selectedWritingQuestion,
            listening_flag: condition.selectedUseListening,
            before_grade_flag: condition.useBeforeGrade,
            selected_max_point_value: this.$store.state.top.selectedMaxPointValue,
            selected_max_point: this.$store.state.top.selectedMaxPoint,
          })
          return accumulator
        }, [])

        if (conditions.length > 0) {
          this.$store.commit('sheet/setSheetSearchCondition', {
            sheetSearchCondition: conditions
          })
        }
      }

      const params = {
        sheet: {
          //並替、差替、追加、削除前のものはすべて削除
          sheet_content_pages_attributes: Object.entries(this.$store.state.sheet.sheetContentPages.sheet_content_pages).map(sheetContentPage => {
            return {                                                        //大問内容の配列
              id:               sheetContentPage[1].id,                        //sheet_content_page_id
              content_page_id:  sheetContentPage[1].content_page.id,           //content_page_id
              number:           sheetContentPage[1].number,                    //大問並び順
              _destroy:         1                                              //削除フラグ
            }
          }),
          step: config.step.REPLACE_CONTENT,
          search_conditions: this.$store.state.sheet.sheetSearchCondition
        }
      }
      // 配点の初期値を入れる処理
      const settingAllots = await this.createSettingAllots()

      //並替、差替、追加、削除後のものを新しく保存
      this.$store.state.sheet.usedItems.map(sheetContentPage => {
        params.sheet.sheet_content_pages_attributes.push({            //大問内容の配列
          content_page_id:  sheetContentPage.contentPageId,             //content_page_id
          number:           sheetContentPage.number,                    //大問並び順
          sheet_questions_attributes:  sheetContentPage.sheetQuestions.map((question, index) => {
            const allot = settingAllots.find(allot => allot.question_id === question.id).value
            return {                                                       //小問内容の配列（今回設定した配点や観点を登録する）
              number:         index+1,                                       //小問並び順
              allot:          allot,                                         //配点
              point_id:       question.pointId,                              //観点ID
              question_id:    question.questionId,                           //小問ID
            }
          })
        })
      })
      //途中保存処理
      await this.$store.dispatch('sheet/updateSheetStatus', params)
    },
    createSettingAllots() {
      const maxPoint = this.$store.state.top.selectedMaxPoint
      // 全設問数
      const totalQuestionCount = this.$store.state.sheet.usedItems
        .map(item => item.sheetQuestions
          .map(sheetQuestion => {
            return sheetQuestion.question.question_cnt
          })
          .reduce((questionCnt, accumlator) => { return accumlator + questionCnt}, 0)
        )
        .reduce((currentItem, accumlator) => { return accumlator + currentItem}, 0)
      // 配点未設定の設問数
      const targetQuestionCount = this.$store.state.sheet.usedItems
        .map(item => item.sheetQuestions
          .map(sheetQuestion => {
            return sheetQuestion.allot ? 0 : sheetQuestion.question.question_cnt
          })
          .reduce((questionCnt, accumlator) => { return accumlator + questionCnt}, 0)
        )
        .reduce((currentItem, accumlator) => { return accumlator + currentItem}, 0)
      // 設定済み配点合計
      const totalSetAllot = this.$store.state.sheet.usedItems
        .map(item => item.sheetQuestions
          .map(sheetQuestion => {
            return sheetQuestion.allot ? sheetQuestion.allot * sheetQuestion.question.question_cnt : 0
          })
          .reduce((questionCnt, accumlator) => { return accumlator + questionCnt}, 0)
        )
        .reduce((currentItem, accumlator) => { return accumlator + currentItem}, 0)

      let settingAllots = this.$store.state.sheet.usedItems
        .map(item => {
          return item.sheetQuestions.map(sheetQuestion => {
            let allot = null
            // 配点リセット（問題の追加、削除を行った時）
            if (this.isAddPrev || this.isAddNext || this.isDeleted) {
              allot = Math.floor(parseInt(maxPoint) / totalQuestionCount)
            } else if (this.isChange) {
              // 問題入替だけをして、入替前の大問の配点より入替後の設問数の方が大きかったら配点リセット
              if (parseInt(maxPoint - totalSetAllot) < targetQuestionCount) {
                allot = Math.floor(parseInt(maxPoint) / totalQuestionCount)
              } else {
                allot = sheetQuestion.allot || Math.floor(parseInt(maxPoint - totalSetAllot) / targetQuestionCount)
              }
            } else {
              allot = sheetQuestion.allot
            }

            return {
              question_id: sheetQuestion.id,
              value: allot,
              question_cnt: sheetQuestion.question.question_cnt
            }
          })
        }).flat()

      let currentTotalAllot = settingAllots.reduce((sum, current) => {
        return sum += current.value * current.question_cnt
      }, 0)

      let loopCnt = 1 // ループの周回
      let index = 0
      // 足りなかったら頭から順に足す
      while(parseInt(maxPoint) > currentTotalAllot && loopCnt < 10) {
        if (index >= settingAllots.length){
          loopCnt += 1
          index = 0
          continue
        }

        // 増やしても収まる問題
        if (settingAllots[index].question_cnt <= parseInt(maxPoint) - currentTotalAllot) {
          if (loopCnt === 1 && settingAllots[index].question_cnt > 1) {
            // 1周目は複数解答持っている設問は避ける
          } else {
            settingAllots[index].value += 1
            // 1点✖︎設問数のため本来は1*settingAllots[index].question_cntだが1*を省略
            currentTotalAllot += settingAllots[index].question_cnt
          }
        }

        index += 1
      }

      // 現在の配点が満点-1点の時だけ特別対応
      let combination = [] // 採用された組合せ
      if (currentTotalAllot == maxPoint - 1) {
        // 設問数の差分が1の設問の組み合わせを探す
        let maxSumQuestionCnt = 99 // 採用された組合せの設問数の合計
        const sheetQuestions = this.$store.state.sheet.usedItems.map(item => item.sheetQuestions).flat()
        for(let i = 0; i < sheetQuestions.length; i++) {
          if (i == sheetQuestions.length - 1) break
          const sheetQuestion = sheetQuestions[i]
          for(let j = 0; j < sheetQuestions.length - (i + 1); j++) {
            if (Math.abs(sheetQuestion.question.question_cnt - sheetQuestions[i + j + 1].question.question_cnt) == 1) {
              const sumQuestionCnt = sheetQuestion.question.question_cnt + sheetQuestions[i + j + 1].question.question_cnt
              if (maxSumQuestionCnt > sumQuestionCnt){
                combination = [sheetQuestion, sheetQuestions[i + j + 1]]
              }
              else if (maxSumQuestionCnt === sumQuestionCnt && combination[1].question.question_cnt < sheetQuestions[i + j + 1].question.question_cnt) {
                combination = [sheetQuestion, sheetQuestions[i + j + 1]]
              }
            }
          }
        }
      }
      if (combination.length == 2){
        const biggerQuestionCntIndex = combination[0].question.question_cnt > combination[1].question.question_cnt ? 0 : 1
        const lowerQuestionCntIndex = combination[0].question.question_cnt > combination[1].question.question_cnt ? 1 : 0
        settingAllots.find(setting => setting.question_id === combination[biggerQuestionCntIndex].id).value += 1
        settingAllots.find(setting => setting.question_id === combination[lowerQuestionCntIndex].id).value -= 1
      }

      return settingAllots
    },
    async toResult(){
      this.$app.$refs.loading.open({type: 'normal', message: '処理中です。少々お待ちください。'})
      await this.save()
      this.$app.$refs.loading.close()
      this.$router.push('/teacher/result')
    },
    toBack() {
      if (this.$store.state.sheet.sheetType === 'shingaku') {
        this.$router.push('/teacher/shingaku_exam')
      } else {
        this.isPresetMode
          ? this.$router.push('/teacher/preset_exam')
          : this.$router.push('/teacher/original_exam')
      }
    },
    tooltipMassage(targetPartNo,type) {
      let msg = ''
      const contentNo = targetPartNo+1
      if(type == 'addPrev')      msg = '大問' + contentNo + 'の前に挿入します'
      else if(type == 'change')  msg = '大問' + contentNo + 'と差し替えます'
      else if(type == 'addNext') msg = '大問' + contentNo + 'の後ろに挿入します'
      return targetPartNo!=null ? msg : '差し替えを行いたい大問の「選択」ボタンを押してください'
    },
    searchShakaiOptionChanged() {
      const subject = this.$store.state.master.allSubjects.find(subject => subject.id === this.selectedShakaiOptionId)

      // 選択した大問の検索条件を設定
      this.$store.commit(
        'setCurrentSubjectCondition',
        {
          currentSubjectCondition: this.$store.state.top.allConditions
            .find(x => x.code === subject.code)
        }
      )
      this.$store.commit('changeCurrentSubjectCondition', {
        selectedMaterials: this.$store.state.master.allMaterials
          .filter(material => material.subject_id === this.selectedSubject.id),
      })
    },
    setStepCols() {
      this.stepCols = getStepCols()
    },
    onClickFavorite(contentCode) {
      let mutationName = ''
      let gradeId = ''
      let isShingaku = false

      const usedItemContent = this.usedItems.find((item) => item.contentCode === contentCode)
      if (usedItemContent) {
        mutationName = 'setFavoriteUsedItem'
        gradeId = usedItemContent.gradeId
        isShingaku = usedItemContent.shinkenkyuNumber ? true : false
      }

      const enableItemContent = this.enableItems.find((item) => item.contentCode === contentCode)
      if (enableItemContent) {
        mutationName = 'setFavoriteEnableItem'
        gradeId = enableItemContent.gradeId
        isShingaku = enableItemContent.shinkenkyuNumber ? true : false
      }

      const subjectTeacherId = this.$store.state.top.subjectTeachers.find(subjectTeacher => {
        if (isShingaku) {
          return subjectTeacher.is_shingaku
        }

        return subjectTeacher.grade.id === gradeId && subjectTeacher.subject.id === this.selectedSubject.id
      })?.id

      if (mutationName) {
        this.$store.dispatch('sheet/deleteOrCreateFavoriteContent', {
          mutationName: mutationName,
          favoriteContentId: mutationName === 'setFavoriteUsedItem' ? usedItemContent.favoriteContentId : enableItemContent.favoriteContentId,
          contentId: mutationName === 'setFavoriteUsedItem' ? usedItemContent.id : enableItemContent.id,
          subjectTeacherId: subjectTeacherId
        })
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.result-btn
  margin-right 10px

.result-score
  float right

.change-heading
  display inline-block

  &__text
    display inline-block

.select-field
  margin-top 30px
  width 300px

.switch-btn
  position absolute
  left 10px

.search-btn
  position absolute
  right 10px

.upper-btn
  position absolute
  right 130px

.change-btn
  position absolute
  right 70px

.down-btn
  position absolute
  right 10px

.preview-btn
  font-weight bold

.buttons
  display flex

.alert
  width 89.3%
  position fixed
  top 80px
  z-index 10

.warning
  width 89.3%
  position fixed
  top 80px
  z-index 10

.slide-right
  &-enter
    transform translate(0px, -200px)

    &-active
      transition all .2s ease-out

    &-to
      transform translate(0px, 0px)

  &-leave
    transform translate(0px, 0px)

    &-active
      transition all .2s ease-out

    &-to
      transform translate(0px, -200px)


.setting-alert
  color:#FF0000;
  font-weight:bold;

</style>
